import { useEffect } from 'react';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../configuration/setup/store';
import { setError } from './errorSlice';

export const HttpRequestFeedbackNotification = () => {
    const dispatch = useDispatch();
    const fetchStatus = useSelector((state: RootState) => state.error);
    useEffect(() => {
        if (fetchStatus.hasError) {
            Notification.error(fetchStatus.errorMessage);
            dispatch(setError({ hasError: false, message: null }));
        }
    }, [fetchStatus]);
    return null;
};
